<script setup lang="ts">
import { storeToRefs } from 'pinia'

import { Brand } from '@xcel-next/core/enums'

import { usePageStore } from '../../stores/page'
// these components will be injected into the app via slots
import PageWrapper from '../../components/PageWrapper.vue'
import HeaderUserNavi from './theme/HeaderUserNavi.vue'
import { useDefaultAppInit, defaultAppInitProps } from '../../composables/use-default-app-init'
import { useClient } from '../../utils/client-only'
import PageFooter from './theme/Footer.vue'
import HeaderLogo from './theme/HeaderLogo.vue'
import HeaderSearch from './theme/HeaderSearch.vue'

import type { DefaultAppInitProps } from '../../composables/use-default-app-init'

const props = withDefaults(defineProps<Partial<DefaultAppInitProps>>(), {
  brand: Brand.tvmovie,
  url: defaultAppInitProps.url.default,
  authorization: defaultAppInitProps.authorization.default,
  consentConfig: null,
  adSizePrediction: null,
  adDefendScript: defaultAppInitProps.adDefendScript.default,
  crawlerDetected: defaultAppInitProps.crawlerDetected.default,
  config: defaultAppInitProps.config.default
})

const { isClient } = useClient()
useDefaultAppInit(props)

const { pageData, brandFromStore } = storeToRefs(usePageStore())
</script>

<template>
  <PageWrapper :page-data="pageData ?? undefined"
               :brand="brandFromStore">
    <template #header-logo>
      <HeaderLogo />
    </template>
    <template #header-search>
      <HeaderSearch />
    </template>
    <template #header-user-navi>
      <HeaderUserNavi />
    </template>
    <template #footer>
      <PageFooter :brand="brandFromStore"
                  :footer-data="pageData?.footer" />
    </template>
    <template #content-top>
      <noscript v-if="isClient"
                class="bx-no-script">
        <strong>Hinweis:</strong> Um unsere Webseite vollständig nutzen zu können, muss JavaScript in Deinem Browser aktiviert sein.<br>
        Viele Funktionen wie das TV-Programm oder die Video-on-Demand-Suche stehen ohne JavaScript nur stark eingeschränkt zur Verfügung.<br>
        <strong>Bitte aktiviere JavaScript in Deinem Browser, um das bestmögliche Nutzungserlebnis zu erhalten.</strong>
      </noscript>
    </template>
  </PageWrapper>
</template>
